module.exports = __webpack_public_path__ + "img/logo.cd0461d9.png";